import { Component, Input } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { ImageFieldValue } from '@core/jss-models';
import { CommonModule } from '@angular/common';
import { CoreJssProxyModule } from '@core/jss-proxy';

@Component({
  selector: 'wl-order-overview-sticker',
  templateUrl: './order-overview-sticker.component.html',
  styleUrls: ['./order-overview-sticker.component.scss'],
  standalone: true,
  imports: [CommonModule, CoreJssProxyModule],
})
export class OrderOverviewStickerComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stickerImage?: ImageFieldValue;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: ComponentRendering;

  get showSticker() {
    return this.offer?.incentiveImage != null || this.stickerImage != null;
  }
}
